import { Layout } from "react-admin";
import { MenuJuristta } from "./menu";
import { JuristtaAppBar } from "./app-bar";

const CustomLayout = (props) => {
    return <Layout {...props} appBar={JuristtaAppBar} menu={MenuJuristta} />
}

export default CustomLayout;
